<div class="flex flex-col">
  <div class="bg-grey-200 page-padding-y page-padding-x">
    <h3 id="h-SRS-Create-Ballot">Systematic Review Ballot</h3>
  </div>

  <form  [formGroup]="ballotForm" class="h-full bg-grey-100">
    <div class="pt-6 pb-6 page-padding-x">
      <div class="flex flex-col gap-6">
        <div class="flex flex-row justify-start gap-6">
          <div class="w-full">
            <label class="mb-2 body-large-bold" for="SRS-Committee-Input" id = "SRS-Committee-Label">
              Committee
            </label>
            <mat-form-field appearance="outline" class="relative w-full mt-1" id="SRS-Committee-Field">
              <input type="text"
                     id="SRS-Committee-Input"
                     placeholder="Enter the committee title or code"
                     aria-label="Number"
                     matInput
                     formControlName="committeeCtrl"
                     [matAutocomplete]="committeeAuto"
                     (input)="typingForSearchCommittee($event)"
                     (focus)="loadingCommitteeOptions()">
              <span class="material-symbols-rounded -ml-9">
                arrow_drop_down
              </span>
              <mat-autocomplete #committeeAuto="matAutocomplete" class="bg-white">
                <mat-option *ngFor="let option of filteredCommitteeOptions | async" [value]="option.value" class="bg-white" (click)= "committeeSelected(option.value)" id="SRS-Committee-Option">
                  {{ option.label }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row justify-start gap-6">
          <div class="w-full">
            <label class="mb-2 body-large-bold" for="SRS-Designation-Input" id="SRS-Designation-Label">
              Designation
            </label>
            <mat-form-field appearance="outline" class="relative w-full mt-1" id="SRS-Designation-Field">
              <input type="text"
                    id="SRS-Designation-Input"
                    placeholder="Enter the designation here or select from the below list"
                    aria-label="Number"
                    matInput
                    formControlName="designationCtrl"
                    [matAutocomplete]="designationAuto"
                    (input)="typingForSearchDesignation($event)"
                    (focus)="loadingDesignationOptions()"
                    >
              <span class="material-symbols-rounded -ml-9">
                arrow_drop_down
              </span>
              <mat-autocomplete  #designationAuto="matAutocomplete" class="bg-white">
                <mat-option *ngFor="let designationOption of filteredDesignationOptions | async" [value]="designationOption.value" class="bg-white" (click)= "selectedDesignation(designationOption)" id="SRS-Designation-Option">
                  {{ designationOption.label }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>


        <div class="flex flex-col gap-6 p-5 bg-white rounded-md shadow-xl">
          <div class="flex items-center w-full gap-2">
            <label class="body-default-bold" for="CommitteeDesignation" id="SRS-Committee-Code-Label">
              Committee Code
            </label>
            <label class="body-default-regular" id="SRS-Committee-Code-Value">
              {{committeeCode}}
            </label>
          </div>

          <div class="flex items-center w-full gap-2">
            <label class="body-default-bold" for="CommitteeDesignation" id="SRS-Committee-Name-Label">
              Committee Name
            </label>
            <label class="body-default-regular" id="SRS-Committee-Name-Value" >
              {{committeeName}}
            </label>
          </div>

          <div class="flex items-center w-full gap-2">
            <label class="body-default-bold" for="CommitteeDesignation" id="SRS-Project-Manager-Label">
              Lead
            </label>
            <label class="body-default-regular" id="SRS-Project-Manager-Value" >
              {{projectManager}}
            </label>
          </div>

          <div class="w-full">
            <label class="body-default-regular" for="OptionsForMembersToVote" id="SRS-Options-For-Members-To-Vote-Label">
              Options for members to vote:
            </label>
            <ul class="pl-5 text-sm list-disc">
              <li id="SRS-Label-Reconfirm">Reconfirm</li>
              <li id="SRS-Label-Revise">Revise</li>
              <li id="SRS-Label-Withdraw">Withdraw</li>
            </ul>
          </div>
        </div>

        <div class="flex flex-row items-start gap-6">
          <app-ballot-create-dates class="flex-1" (selectedDatesChange)="handleSelectedDatesChange($event)"></app-ballot-create-dates>
          <div class="flex flex-col items-center w-1/6 mb-2" >
            <p id="SRS-Decision-Button-Text" class="mb-1 -translate-y-1" >Click here if the Committee has made a decision and a ballot is not required:</p>
            <button class="px-5 py-3 btn btn-primary h-[50px]" [disabled]="!isDecisionEnabled" id="SRS-Decision-Button" (click)="openDecisionModal()">Decision</button>
          </div>
        </div>
        <div class="flex justify-end gap-6 mt-5 mr-10 mb-72">
          <button class="px-8 py-3 border border-black btn btn-neutral" id="SRS-Cancel-Button" (click)="redirectToCreateBallotPage()" type="button">Cancel</button>
          <button class="px-8 py-3 btn btn-primary" [disabled]="!isCreateBallotEnabled" id="SRS-Create-Ballot-Button" (click)="createSRSBallot()">Create Ballot</button>
        </div>
      </div>
    </div>
  </form>
</div>
